import React from 'react';
import Hyperspeed from '../../components/Hyperspeed';
import { hyperspeedPresets } from '../../components/HyperSpeedPresets';
import avatecLogo from '../../assets/logos/avatec-white.png';
import './Slide1.css';

function Slide1() {
  return (
    <div className="slide slide1">
      <img src={avatecLogo} alt="Avatec Marine" className="slide-logo" />
      <div className="slide1-background">
        <Hyperspeed effectOptions={hyperspeedPresets.one} />
      </div>

      <div className="slide1-content">
        <div className="slide1-brand">
          <img src="/images/ava_logo/Avatec_White_Horizontal_Big_trim.PNG" alt="Avatec Marine" className="slide1-main-logo" />
          <div className="slide1-brand-sep"></div>
          <span className="slide1-brand-name">Avatec Marine</span>
        </div>
        <p className="slide1-subtitle">Solutions to Power Your Business Globally</p>
      </div>
    </div>
  );
}

export default Slide1;
